import React from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Grid, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import { useService } from '../ServiceContext'
import VerifiedIcon from '@mui/icons-material/Verified';
export default function ConditionsTreat() {
  const { service } = useService()
  // Ensure service and conditionsTreat exist, fallback to empty array if not
  const conditions = service?.conditionsTreat?.points;
  let leftColumn = [];
  let rightColumn = [];
  if (Array.isArray(conditions) && conditions.length > 0) {
    const midIndex = Math.ceil(conditions.length / 2);
    leftColumn = conditions.slice(0, midIndex);
    rightColumn = conditions.slice(midIndex);
  }
  // If conditionsTreat is undefined, render a fallback or nothing
  if (!service.conditionsTreat) {
    return <div>Loading conditions data...</div> // Or any fallback UI
  }

  return (
    <div>
      <div>
        <h2 className='font-heading text-[38px] font-[500] leading-[1.316em] mb-6 text-thickGreen'>
          {service.conditionsTreat.heading}
        </h2>
        {service.conditionsTreat.paragraph && service.conditionsTreat.paragraph.map((para, index) => (
          <p
            key={index}
            className='text-[18px] font-body text-paraGreen font-[500] leading-[1.667em] mb-4'
          >
            {para}
          </p>
        ))}
      </div>
      {service?.conditionsTreat?.points && <Grid container spacing={4} className='mb-8'>
        {/* Left Column */}
        <Grid item xs={12} sm={6} md={5} sx={{ fontFamily: 'Work Sans' }}>
          <List>
            {leftColumn.map((condition, index) => (
              <ListItem
                key={index}
                sx={{
                  paddingBottom: '0px',
                  paddingTop: '0px',
                  fontFamily: 'Work Sans'
                }}
              >
                <ListItemIcon>
                  <CheckCircleIcon className='text-orange' />
                </ListItemIcon>
                <ListItemText
                  primary={condition}
                  sx={{ fontFamily: 'Work Sans' }}
                  className='text-[15px] font-body text-paraGreen font-bold leading-[1.667em]'
                />
              </ListItem>
            ))}

          </List>
        </Grid>
        {/* Right Column */}
        <Grid item xs={12} sm={6} md={5}>
          <List>
            {rightColumn.map((condition, index) => (
              <ListItem
                key={index}
                sx={{ paddingBottom: '0px', paddingTop: '0px' }}
              >
                <ListItemIcon>
                  <CheckCircleIcon className='text-orange' />
                </ListItemIcon>
                <ListItemText
                  primary={condition}
                  className='text-[15px] font-body text-paraGreen font-bold leading-[1.667em]'
                />
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>

      }

      {service?.conditionsTreat?.experties && <>

        <p className='uppercase font-bold text-xl font-heading text-lightGreen mb-3'>{service?.conditionsTreat?.experties.title}</p>
        <div className='flex sm:flex-row flex-col font-sans'>
          <div className='sm:w-1/2 w-full'>
            {service?.conditionsTreat?.experties?.points.slice(0, 12).map((condition, index) => (
              <ListItem
                key={index}
                sx={{
                  paddingBottom: '0px',
                  paddingTop: '0px',
                  fontFamily: 'Work Sans'
                }}
              >
                <ListItemIcon>
                  <CheckCircleIcon className='text-orange' />
                </ListItemIcon>
                <ListItemText
                  primary={condition}
                  sx={{ fontFamily: 'Work Sans' }}
                  className='text-[15px] font-body text-paraGreen font-bold leading-[1.667em]'
                />
              </ListItem>
            ))}
          </div>
          <div className='sm:w-1/2 w-full'>
            {service?.conditionsTreat?.experties?.points.slice(12,).map((condition, index) => (
              <ListItem
                key={index}
                sx={{
                  paddingBottom: '0px',
                  paddingTop: '0px',
                  fontFamily: 'Work Sans'
                }}
              >
                <ListItemIcon>
                  <CheckCircleIcon className='text-orange' />
                </ListItemIcon>
                <ListItemText
                  primary={condition}
                  sx={{ fontFamily: 'Work Sans' }}
                  className='text-[15px] font-body text-paraGreen font-bold leading-[1.667em]'
                />
              </ListItem>
            ))}</div>
        </div>
      </>
      }
      {service?.conditionsTreat?.servicecOffered && <>
        <p className='uppercase font-bold text-xl font-heading text-lightGreen mb-3 mt-2'>{service?.conditionsTreat?.servicecOffered.title}</p>
        <div className='flex sm:flex-row flex-col font-sans mb-5'>
          <div className='sm:w-1/2 w-full '>
            {service?.conditionsTreat?.servicecOffered?.points.slice(0, 5).map((condition, index) => (
              <ListItem
                key={index}
                sx={{
                  paddingBottom: '0px',
                  paddingTop: '0px',
                  fontFamily: 'Work Sans'
                }}
              >
                <ListItemIcon>
                  <CheckCircleIcon className='text-orange' />
                </ListItemIcon>
                <ListItemText
                  primary={condition}
                  sx={{ fontFamily: 'Work Sans' }}
                  className='text-[15px] font-body text-paraGreen font-bold leading-[1.667em]'
                />
              </ListItem>
            ))}
          </div>
          <div className='sm:w-1/2 w-full'>
            {service?.conditionsTreat?.servicecOffered?.points.slice(5,).map((condition, index) => (
              <ListItem
                key={index}
                sx={{
                  paddingBottom: '0px',
                  paddingTop: '0px',
                  fontFamily: 'Work Sans'
                }}
              >
                <ListItemIcon>
                  <CheckCircleIcon className='text-orange' />
                </ListItemIcon>
                <ListItemText
                  primary={condition}
                  sx={{ fontFamily: 'Work Sans' }}
                  className='text-[15px] font-body text-paraGreen font-bold leading-[1.667em]'
                />
              </ListItem>
            ))}</div>
        </div>

      </>
      }

      <Grid container spacing={4} className='mb-8'>
        {service.conditionsTreat.images.map((image, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <div className=''>
              <img src={image} alt='' className='rounded-[30px] object-cover md:h-[250px] w-full' />
            </div>
          </Grid>
        ))}
      </Grid>

      {
        service.tips && <div className='mb-8'>
          <h2 className='font-heading text-[38px] font-[500] leading-[1.316em] mb-6 text-thickGreen'>
            {service.tips.title}
          </h2>
          <ul className='text-lg font-body text-paraGreen font-[500] '>
            {service.tips.points.map((item, index) => (
              <li key={index} className='mb-4 flex flex-row items-center gap-3'>
                <VerifiedIcon className='flex-shrink-0 text-orange text-lg' />   {item}
              </li>
            ))}
          </ul>
        </div>}
      {service.galance && <div className='mb-8'>
        <h2 className='font-heading text-[38px] font-[500] leading-[1.316em] mb-6 text-thickGreen'>
          {service.galance.title}
        </h2>
        <ul className='text-[18px] font-body text-paraGreen font-[500] leading-[1.667em]'>
          {service.galance.content.map((item, index) => (
            <li key={index} className='mb-4'>
              {item}
            </li>
          ))}
        </ul>
      </div>}
      {service.tools && service.tools.length > 0 && (
        <div className='mb-12'>
          <h2 className='font-heading text-[38px] font-[500] leading-[1.316em] mb-6 text-thickGreen'>
            {service.latestTecTitle}
          </h2>
          <div className='border border-[#DADEE2] border-b-[6px] shadow-sm rounded-lg mt-[15px] mb-[35px] p-5 transition-all duration-300'>
            <ul className='text-[18px] font-medium leading-[1.667em] text-thickGreen'>
              {service.tools.map((tool, index) => (
                <li key={index} className='flex items-center'>
                  <CheckIcon
                    className='text-orange mr-4'
                    style={{ fontSize: '20px' }}
                  />
                  <span className='font-body font-[600]' style={{

                  }}>{tool}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  )
}
